<template>
  <div class="bcb-campaign-detail container-fluid">
    <div class="campaign-header d-flex align-items-center my-6">
      <button class="btn btn-icon btn-light mr-3" @click="$router.push({ name: 'bcb-campaign' })">
        <i class="fas fa-arrow-left"></i>
      </button>
      <div class="flex-grow-1">
        <h4 class="text-dark font-weight-bold mb-1">Theo dõi Campaign</h4>
        <p class="text-muted m-0">{{ dashboard.campaignName || detailName }}</p>
      </div>
      <button
        v-if="isUpdatePermission"
        class="btn btn-warning font-weight-medium"
        @click="$router.push({ name: 'bcb-campaign-edit', params: { id: campaignId } })"
      >
        <i class="fas fa-edit mr-2"></i>Chỉnh sửa
      </button>
    </div>

    <b-overlay :show="loading || dashboardLoading">
      <div class="dashboard-summary card card-custom gutter-b">
        <div class="card-body d-flex align-items-center justify-content-between flex-wrap">
          <div class="summary-grid flex-grow-1">
            <div class="summary-item">
              <div class="summary-label">Công ty</div>
              <div class="summary-value">{{ dashboard.campaignName || '—' }}</div>
            </div>
            <div class="summary-item">
              <div class="summary-label">Tổng nhân viên</div>
              <div class="summary-value">{{ formatNumber(dashboard.totalEmployees) }}</div>
            </div>
            <div class="summary-item">
              <div class="summary-label">Thời gian</div>
              <div class="summary-value">{{ campaignTime }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="partner-statistics card card-custom gutter-b">
        <div class="card-body">
          <h5 class="font-weight-bold text-dark mb-5">Phân bổ nhân viên theo đối tác phòng khám</h5>
          <div v-if="dashboardPartners.length" class="partner-statistics-grid">
            <div
              v-for="partner in dashboardPartners"
              :key="partner.partnerId || partner.id || partner.partnerName"
              class="partner-statistics-card partner-statistics-card--clickable"
              role="button"
              tabindex="0"
              @click="openPartnerCustomers(partner)"
              @keyup.enter="openPartnerCustomers(partner)"
            >
              <div class="partner-statistics-header">
                <div class="partner-statistics-name">{{ partner.partnerName || partner.name || '—' }}</div>
                <b-badge pill :variant="partnerExamPercent(partner) > 0 ? 'success' : 'secondary'">
                  {{ formatPercent(partnerExamPercent(partner)) }}
                </b-badge>
              </div>
              <div class="partner-statistics-lines">
                <div class="partner-statistics-line">
                  <span>Tổng số</span>
                  <strong>{{ formatNumber(partner.totalCustomers) }}</strong>
                </div>
                <div class="partner-statistics-line">
                  <span>Đã khám</span>
                  <strong class="text-success">{{ formatNumber(partner.examCompletedCount) }}</strong>
                </div>
                <div class="partner-statistics-line">
                  <span>Chưa khám</span>
                  <strong class="text-danger">{{ formatNumber(partner.notExamCompletedCount) }}</strong>
                </div>
              </div>
              <div class="partner-statistics-progress">
                <div
                  class="partner-statistics-progress-bar"
                  :style="{ width: `${Math.min(partnerExamPercent(partner), 100)}%` }"
                />
              </div>
            </div>
          </div>
          <div v-else class="partner-statistics-empty">
            Chưa có dữ liệu phòng khám
          </div>
        </div>
      </div> -->

      <div class="metric-grid mb-5">
        <div
          v-for="metric in dashboardMetrics"
          :key="metric.key"
          class="metric-card metric-card--clickable"
          role="button"
          tabindex="0"
          @click="openMetricCustomers(metric)"
          @keyup.enter="openMetricCustomers(metric)"
        >
          <div class="d-flex justify-content-between align-items-start mb-4">
            <span class="metric-icon" :class="`metric-icon--${metric.colorVariant || 'primary'}`">
              <i :class="metricIcon(metric.key)"></i>
            </span>
            <b-badge pill :variant="metric.colorVariant || 'primary'">
              {{ formatPercent(metric.percent) }}
            </b-badge>
          </div>
          <div class="metric-value">{{ formatNumber(metric.count) }}</div>
          <div class="metric-label">{{ metric.label }}</div>
        </div>
      </div>

      <!-- <div class="card card-custom gutter-b">
        <div class="card-body">
          <h5 class="font-weight-bold text-dark mb-6">Phễu tiến độ Campaign</h5>
          <div class="funnel-scroll">
            <div class="funnel">
              <div
                v-for="(step, index) in dashboardFunnel"
                :key="step.key"
                class="funnel-step"
              >
                <div
                  class="funnel-bar"
                  :style="funnelBarStyle(step, index)"
                >
                  <div class="funnel-label">{{ step.label }}</div>
                  <div class="funnel-count">{{ formatNumber(step.count) }}</div>
                  <div class="funnel-percent">{{ formatPercent(step.percentOfTotal) }} tổng số nhân viên</div>
                  <div v-if="index > 0" class="funnel-percent">
                    Tỷ lệ chuyển đổi: {{ formatPercent(step.conversionPercent) }}
                  </div>
                </div>
                <div v-if="index > 0" class="funnel-drop">
                  ↓ Chưa hoàn thành {{ formatNumber(step.notCompletedCount) }} người
                  ({{ formatPercent(step.notCompletedPercent) }})
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="bg-white rounded border">
        <b-tabs v-model="activeTab" class="p-4">
          <b-tab title="Danh sách KH">
            <div class="pt-4">
              <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                <basic-select
                  label=""
                  placeholder="Lọc theo trạng thái"
                  name="customerStatus"
                  :options="customerStatusOptions"
                  track-by="value"
                  value-label="text"
                  :value.sync="customerStatusFilter"
                  @input="onCustomerStatusChange"
                  class="mb-0 mr-3"
                  style="min-width: 220px;"
                />
                <!-- <button class="btn btn-outline-success mt-3 mt-md-0" @click="$bvModal.show('modal-bcb-campaign-customer-import')">
                  <i class="fas fa-file-excel mr-2"></i>Import KH từ Excel
                </button> -->
                <bcb-campaign-customer-import
                  :campaign-id="campaignId"
                  @import-success="onImportSuccess"
                />
              </div>

              <b-overlay :show="customerLoading">
                <template-table
                  :column="customerColumns"
                  :data="customers"
                  :paging="customerPaging"
                  :loading="customerLoading"
                  :select-action="false"
                  :table-action="true"
                  @change-page="onCustomerChangePage"
                >
                  <template #body="{ item }">
                    <td>{{ item.fullName || '—' }}</td>
                    <td>{{ item.dateOfBirth ? formatDate(item.dateOfBirth) : '—' }}</td>
                    <td class="text-center">{{ item.gender === 1 ? 'Nam' : item.gender === 0 ? 'Nữ' : '—' }}</td>
                    <td>{{ item.phone || '—' }}</td>
                    <td>{{ item.email || '—' }}</td>
                    <td>{{ item.companyName || '—' }}</td>
                    <td class="text-center">
                      <span class="status-badge" :style="getCustomerStatusStyle(item.status)">
                        {{ getCustomerStatusLabel(item.status) }}
                      </span>
                    </td>
                    <td>{{ item.partnerName || '—' }}</td>
                    <td>{{ item.appointment?.[0]?.examDate ? formatDate(item.appointment[0].examDate) : '—' }}</td>
                    <td>{{ item.appointment?.[0]?.startTime ? formatTime(item.appointment[0].startTime) + ' - ' + formatTime(item.appointment[0].endTime) : '—' }}</td>
                  </template>
                  <template #action="{ item }">
                      <button class="btn btn-sm btn-icon btn-light" @click="viewCustomer(item)" title="Chi tiết khách hàng">
                        <i class="fas fa-eye text-primary"></i>
                      </button>
                  </template>
                </template-table>
              </b-overlay>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-overlay>

    <b-modal
      id="bcb-partner-customers-modal"
      modal-class="bcb-partner-customers-modal"
      size="xl"
      centered
      hide-footer
      @hidden="onPartnerCustomersModalHidden"
    >
      <template #modal-title>
        {{ selectedPartnerName }}
      </template>

      <div class="metric-modal-toolbar mb-4">
        <div class="metric-modal-total">
          Tổng số: {{ formatNumber(partnerCustomerPaging.total) }} nhân viên
        </div>
        <BasicSelect
          class="partner-status-filter"
          :options="customerStatusOptions"
          track-by="value"
          value-label="text"
          :value.sync="partnerCustomerStatusFilter"
          placeholder="Tất cả trạng thái"
          @input="onPartnerCustomerStatusChange"
        />
      </div>

      <b-overlay :show="partnerCustomerLoading">
        <template-table
          :column="partnerCustomerColumns"
          :data="partnerCustomers"
          :paging="partnerCustomerPaging"
          :loading="partnerCustomerLoading"
          :select-action="false"
          :table-action="true"
          @change-page="onPartnerCustomerChangePage"
        >
          <template #body="{ item }">
            <td class="text-center">{{ item.index || '—' }}</td>
            <td>{{ item.fullName || '—' }}</td>
            <td>{{ item.phone || '—' }}</td>
            <td>{{ item.email || '—' }}</td>
            <td>{{ item.department || '—' }}</td>
            <td>
              <span class="status-badge" :style="getCustomerStatusStyle(item.status)">
                {{ getCustomerStatusLabel(item.status) }}
              </span>
            </td>
            <td>{{ item.performedAt ? formatDate(item.performedAt) : '—' }}</td>
          </template>
          <template #action="{ item }">
            <button class="btn btn-sm btn-icon btn-light" @click="viewCustomer(item)" title="Chi tiết khách hàng">
              <i class="fas fa-eye text-primary"></i>
            </button>
          </template>
        </template-table>
      </b-overlay>
    </b-modal>

    <b-modal
      id="bcb-dashboard-customers-modal"
      modal-class="bcb-dashboard-customers-modal"
      size="xl"
      centered
      hide-footer
    >
      <template #modal-title>
        {{ selectedMetricLabel }}
      </template>

      <div class="metric-modal-toolbar mb-4">
        <div class="metric-modal-total">
          Tổng số: {{ formatNumber(selectedMetricCount) }} nhân viên
        </div>
        <button
          v-if="isExamCompletedMetric"
          class="btn btn-outline-success"
          type="button"
          :disabled="examCompletedImporting"
          @click="$refs.examCompletedFileUpload.click()"
        >
          <b-spinner v-if="examCompletedImporting" small class="mr-2" />
          <i v-else class="fas fa-file-upload mr-2"></i>
          Upload DS đã khám
        </button>
        <input
          v-show="false"
          ref="examCompletedFileUpload"
          type="file"
          accept=".xlsx, .xls"
          @change="onUploadExamCompletedFile"
        />
      </div>

      <b-overlay :show="metricCustomerLoading || examCompletedImporting">
        <template-table
          :column="metricCustomerColumns"
          :data="metricCustomers"
          :paging="metricCustomerPaging"
          :loading="metricCustomerLoading"
          :select-action="false"
          :table-action="true"
          @change-page="onMetricCustomerChangePage"
        >
          <template #body="{ item }">
            <td class="text-center">{{ item.index || '—' }}</td>
            <td>{{ item.fullName || '—' }}</td>
            <td>{{ item.email || '—' }}</td>
            <td>{{ item.department || '—' }}</td>
            <td>{{ item.performedAt ? formatDate(item.performedAt) : '—' }}</td>
          </template>
          <template #action="{ item }">
              <button class="btn btn-sm btn-icon btn-light" @click="viewCustomer(item)" title="Chi tiết khách hàng">
                <i class="fas fa-eye text-primary"></i>
              </button>
          </template>
        </template-table>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { CUSTOMER_STATUS, CUSTOMER_STATUS_WORKFLOW_OPTIONS } from '../constants/index.js';
import { EXCEL_FILE_TYPE } from '@/core/plugins/constants';
import BcbCampaignCustomerImport from './BcbCampaignCustomerImport.vue';

export default {
  name: 'BcbCampaignDetail',
  components: { BcbCampaignCustomerImport },
  props: {
    id: { type: [String, Number], default: null },
  },
  data() {
    return {
      loading: false,
      customerLoading: false,
      dashboardLoading: false,
      metricCustomerLoading: false,
      partnerCustomerLoading: false,
      examCompletedImporting: false,
      activeTab: 0,
      detail: null,
      dashboard: {},
      customers: [],
      metricCustomers: [],
      partnerCustomers: [],
      selectedMetric: null,
      selectedPartner: null,
      customerPaging: { page: 1, pageSize: 10, total: 0 },
      metricCustomerPaging: { page: 1, pageSize: 10, total: 0 },
      partnerCustomerPaging: { page: 1, pageSize: 10, total: 0 },
      filterStatus: null,
      customerStatusFilter: null,
      partnerCustomerStatus: null,
      partnerCustomerStatusFilter: null,
      customerStatusMap: CUSTOMER_STATUS,
      customerStatusOptions: [{ value: null, text: 'Tất cả trạng thái' }, ...CUSTOMER_STATUS_WORKFLOW_OPTIONS],
      customerColumns: [
        { key: 'fullName', label: 'Họ và tên' },
        { key: 'dateOfBirth', label: 'Ngày sinh' },
        { key: 'gender', label: 'Giới tính' },
        { key: 'phone', label: 'Số điện thoại' },
        { key: 'email', label: 'Email' },
        { key: 'companyName', label: 'Công ty' },
        { key: 'status', label: 'Trạng thái' },
        { key: 'partnerName', label: 'Phòng khám' },
        { key: 'examDate', label: 'Ngày khám' },
        { key: 'examTime', label: 'Thời gian khám' },

      ],
      metricCustomerColumns: [
        { key: 'index', label: 'STT', class: 'text-center' },
        { key: 'fullName', label: 'Họ tên' },
        { key: 'email', label: 'Email' },
        { key: 'department', label: 'Phòng ban' },
        { key: 'performedAt', label: 'Ngày thực hiện' },
      ],
      partnerCustomerColumns: [
        { key: 'index', label: 'STT', class: 'text-center' },
        { key: 'fullName', label: 'Họ tên' },
        { key: 'phone', label: 'Số điện thoại' },
        { key: 'email', label: 'Email' },
        { key: 'department', label: 'Phòng ban' },
        { key: 'status', label: 'Trạng thái' },
        { key: 'performedAt', label: 'Ngày thực hiện' },
      ],
    };
  },
  computed: {
    campaignId() {
      return this.id || this.$route.params.id || null;
    },
    detailName() {
      return this.detail?.name || 'Corporate Health Campaign';
    },
    dashboardMetrics() {
      return (this.dashboard?.metrics || []).filter(m => m.key !== 'registeredSlot');
    },
    dashboardFunnel() {
      return this.dashboard?.funnel || [];
    },
    dashboardPartners() {
      return this.dashboard?.partners || [];
    },
    campaignTime() {
      const startDate = this.dashboard?.startDate || this.detail?.startDate;
      const endDate = this.dashboard?.endDate;
      return `${this.formatDate(startDate)} - ${endDate ? this.formatDate(endDate) : '—'}`;
    },
    selectedMetricLabel() {
      return this.selectedMetric?.label || 'Danh sách nhân viên';
    },
    selectedMetricCount() {
      return this.selectedMetric?.count || 0;
    },
    isExamCompletedMetric() {
      return this.selectedMetric?.key === 'examCompleted';
    },
    selectedPartnerName() {
      return this.selectedPartner?.partnerName || this.selectedPartner?.name || 'Danh sách nhân viên phòng khám';
    },
  },
  watch: {
    'customerPaging.page'() { this.loadCustomers(); },
    'customerPaging.pageSize'() { this.customerPaging.page = 1; this.loadCustomers(); },
    'metricCustomerPaging.page'() { this.loadMetricCustomers(); },
    'metricCustomerPaging.pageSize'() { this.metricCustomerPaging.page = 1; this.loadMetricCustomers(); },
    'partnerCustomerPaging.page'() { this.loadPartnerCustomers(); },
    'partnerCustomerPaging.pageSize'() { this.partnerCustomerPaging.page = 1; this.loadPartnerCustomers(); },
  },
  created() {
    this.loadDetail();
    this.loadDashboard();
    this.loadCustomers();
  },
  methods: {
    async loadDetail() {
      this.loading = true;
      try {
        const res = await this.$api.get(`BcbCampaign/${this.campaignId}`);
        this.detail = res?.data ?? res;
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể tải thông tin chiến dịch.' });
      } finally {
        this.loading = false;
      }
    },
    async loadDashboard() {
      this.dashboardLoading = true;
      try {
        const res = await this.$api.get(`BcbCampaign/${this.campaignId}/dashboard`);
        this.dashboard = res?.data ?? res ?? {};
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể tải dashboard chiến dịch.' });
      } finally {
        this.dashboardLoading = false;
      }
    },
    async loadCustomers() {
      this.customerLoading = true;
      try {
        const params = { page: this.customerPaging.page, size: this.customerPaging.pageSize };
        if (this.filterStatus != null) params.status = this.filterStatus;

        const res = await this.$api.get(`BcbCampaign/${this.campaignId}/customers`, { params });
        const raw = res?.data ?? res;
        const list = raw?.items ?? raw?.data?.items ?? (Array.isArray(raw) ? raw : []);
        this.customers = list;
        this.customerPaging.total = raw?.total ?? raw?.data?.total ?? list.length;
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: 'Không thể tải danh sách khách hàng.' });
      } finally {
        this.customerLoading = false;
      }
    },
    async loadMetricCustomers() {
      if (!this.selectedMetric) return;

      this.metricCustomerLoading = true;
      try {
        const params = {
          metricKey: this.selectedMetric.key,
          page: this.metricCustomerPaging.page,
          size: this.metricCustomerPaging.pageSize,
        };
        const res = await this.$api.get(`BcbCampaign/${this.campaignId}/dashboard-customers`, { params });
        const raw = res?.data ?? res;
        const list = raw?.items ?? raw?.data?.items ?? (Array.isArray(raw) ? raw : []);
        this.metricCustomers = list.map((item, index) => ({
          ...item,
          index: item.index || ((this.metricCustomerPaging.page - 1) * this.metricCustomerPaging.pageSize) + index + 1,
        }));
        this.metricCustomerPaging.total = raw?.total ?? raw?.data?.total ?? list.length;
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: 'Không thể tải danh sách nhân viên.' });
      } finally {
        this.metricCustomerLoading = false;
      }
    },
    openMetricCustomers(metric) {
      this.selectedMetric = metric;
      this.metricCustomers = [];
      this.metricCustomerPaging.page = 1;
      this.metricCustomerPaging.total = metric?.count || 0;
      this.$bvModal.show('bcb-dashboard-customers-modal');
      this.loadMetricCustomers();
    },
    onMetricCustomerChangePage(page) {
      this.metricCustomerPaging.page = page;
      this.loadMetricCustomers();
    },
    async loadPartnerCustomers() {
      if (!this.selectedPartner) return;

      const partnerId = this.selectedPartner.partnerId || this.selectedPartner.id;
      if (!partnerId) return;

      this.partnerCustomerLoading = true;
      try {
        const params = {
          partnerId,
          page: this.partnerCustomerPaging.page,
          size: this.partnerCustomerPaging.pageSize,
        };
        if (this.partnerCustomerStatus != null) params.status = this.partnerCustomerStatus;

        const res = await this.$api.get(`BcbCampaign/${this.campaignId}/dashboard-customers`, { params });
        const raw = res?.data ?? res;
        const list = raw?.items ?? raw?.data?.items ?? (Array.isArray(raw) ? raw : []);
        this.partnerCustomers = list.map((item, index) => ({
          ...item,
          index: item.index || ((this.partnerCustomerPaging.page - 1) * this.partnerCustomerPaging.pageSize) + index + 1,
        }));
        this.partnerCustomerPaging.total = raw?.total ?? raw?.data?.total ?? list.length;
      } catch (e) {
        this.$toastr.e({ title: 'Lá»—i', msg: 'KhÃ´ng thá»ƒ táº£i danh sÃ¡ch nhÃ¢n viÃªn phÃ²ng khÃ¡m.' });
      } finally {
        this.partnerCustomerLoading = false;
      }
    },
    openPartnerCustomers(partner) {
      this.selectedPartner = partner;
      this.partnerCustomers = [];
      this.partnerCustomerStatus = null;
      this.partnerCustomerStatusFilter = null;
      this.partnerCustomerPaging.page = 1;
      this.partnerCustomerPaging.total = partner?.totalCustomers || 0;
      this.$bvModal.show('bcb-partner-customers-modal');
      this.loadPartnerCustomers();
    },
    onPartnerCustomerStatusChange(value) {
      this.partnerCustomerStatus = value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'value')
        ? value.value
        : value;
      this.partnerCustomerPaging.page = 1;
      this.loadPartnerCustomers();
    },
    onPartnerCustomerChangePage(page) {
      this.partnerCustomerPaging.page = page;
      this.loadPartnerCustomers();
    },
    onPartnerCustomersModalHidden() {
      this.selectedPartner = null;
      this.partnerCustomerStatus = null;
      this.partnerCustomerStatusFilter = null;
      this.partnerCustomers = [];
    },
    async onUploadExamCompletedFile(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (!EXCEL_FILE_TYPE.includes(file.type)) {
        this.$refs.examCompletedFileUpload.value = null;
        this.$toastr.e({ title: 'Lỗi', msg: 'Chỉ hỗ trợ file .xlsx hoặc .xls' });
        return;
      }

      try {
        this.examCompletedImporting = true;
        const formData = new FormData();
        formData.append('importFile', file);
        formData.append('campaignId', this.campaignId);

        const { meta, data, error } = await this.$api.post(
          'BcbCampaignCustomer/import-exam-completed',
          formData,
        );

        if (!meta?.success) {
          this.$toastr.e({ title: 'Lỗi', msg: error?.message || 'Upload danh sách đã khám thất bại' });
          return;
        }

        const totalSuccess = data?.totalSuccess || 0;
        const totalFail = data?.totalFail || 0;
        this.$toastr.s({
          title: 'Thành công',
          msg: `Đã cập nhật ${totalSuccess} khách hàng đã khám${totalFail ? `, ${totalFail} dòng lỗi` : ''}.`,
        });
        this.loadDashboard();
        this.loadCustomers();
        if (this.selectedMetric) this.loadMetricCustomers();
        if (this.selectedPartner) this.loadPartnerCustomers();
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể upload danh sách đã khám.' });
      } finally {
        this.examCompletedImporting = false;
        if (this.$refs.examCompletedFileUpload) this.$refs.examCompletedFileUpload.value = null;
      }
    },
    onCustomerStatusChange(value) {
      this.filterStatus = value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'value')
        ? value.value
        : value;
      this.customerPaging.page = 1;
      this.loadCustomers();
    },
    onCustomerChangePage(page) {
      this.customerPaging.page = page;
      this.loadCustomers();
    },
    getCustomerId(row) {
      return row?.id || row?.customerId || row?.campaignCustomerId || row?.bcbCampaignCustomerId;
    },
    viewCustomer(row) {
      const customerId = this.getCustomerId(row);
      if (!customerId) {
        this.$toastr.e({ title: 'Lỗi', msg: 'Không tìm thấy ID khách hàng.' });
        return;
      }
      this.$bvModal.hide('bcb-dashboard-customers-modal');
      this.$bvModal.hide('bcb-partner-customers-modal');
      this.$router.push({
        name: 'bcb-campaign-customer-detail',
        params: { campaignId: String(this.campaignId), customerId: String(customerId) },
      });
    },
    onImportSuccess() {
      this.loadCustomers();
      this.loadDashboard();
    },
    getCustomerStatusLabel(status) {
      return CUSTOMER_STATUS[status]?.label || '—';
    },
    getCustomerStatusStyle(status) {
      const cfg = CUSTOMER_STATUS[status];
      return {
        backgroundColor: cfg?.bg || '#F1EFE8',
        color: cfg?.color || '#444441',
      };
    },
    metricIcon(key) {
      const map = {
        sentNotification: 'fas fa-users',
        registeredSlot: 'far fa-calendar-alt',
        appointmentConfirmed: 'fas fa-bullseye',
        examCompleted: 'far fa-clock',
        resultReceived: 'far fa-check-circle',
      };
      return map[key] || 'fas fa-chart-line';
    },
    funnelBarStyle(step, index) {
      const widths = [1248, 1061, 874, 686, 499];
      return {
        width: `${widths[index] || widths[widths.length - 1]}px`,
        backgroundColor: step.color || '#1976d2',
      };
    },
    formatNumber(value) {
      return Number(value || 0).toLocaleString('vi-VN');
    },
    formatPercent(value) {
      return `${Number(value || 0).toFixed(1)}%`;
    },
    partnerExamPercent(partner) {
      return Number(partner?.examCompletedPercent || 0);
    },
    formatDate(val) {
      if (!val) return '—';
      if (typeof val === 'number') {
        return this.$moment.unix(val).utcOffset('+07:00').format('DD/MM/YYYY');
      }
      return this.$moment(val).utcOffset('+07:00').format('DD/MM/YYYY');
    },
    formatTime(val) {
      if (!val) return '—';
      if (typeof val === 'string') return val.slice(0, 5);
      return val;
    },
  },
};
</script>

<style scoped lang="scss">
.bcb-campaign-detail {
  background: #f9fafb;
  padding-bottom: 32px;
}

.dashboard-summary {
  border-radius: 4px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(160px, 1fr));
  gap: 24px;
}

.summary-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.summary-label,
.metric-label {
  color: #6a7282;
  font-size: 14px;
  line-height: 20px;
}

.summary-value {
  color: #181c32;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.partner-statistics {
  border-radius: 4px;
}

.partner-statistics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 14px;
}

.partner-statistics-card {
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 150px;
  padding: 16px;
}

.partner-statistics-card--clickable {
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:focus,
  &:hover {
    border-color: #1976d2;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.16);
    outline: none;
    transform: translateY(-1px);
  }
}

.partner-statistics-header,
.partner-statistics-line {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.partner-statistics-name {
  color: #181c32;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.partner-statistics-lines {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.partner-statistics-line {
  color: #6a7282;
  font-size: 14px;
  line-height: 20px;

  strong {
    color: #181c32;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
}

.partner-statistics-progress {
  background: #e4e6ef;
  border-radius: 4px;
  height: 8px;
  overflow: hidden;
  width: 100%;
}

.partner-statistics-progress-bar {
  background: #4caf50;
  border-radius: 4px;
  height: 100%;
  min-width: 0;
  transition: width 0.2s ease;
}

.partner-statistics-empty {
  align-items: center;
  border: 1px dashed #d1d5db;
  border-radius: 4px;
  color: #6a7282;
  display: flex;
  justify-content: center;
  min-height: 96px;
  text-align: center;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(160px, 1fr));
  gap: 14px;
}

.metric-card {
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  min-height: 128px;
  padding: 16px;
}

.metric-card--clickable {
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:focus,
  &:hover {
    border-color: #1976d2;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.16);
    outline: none;
    transform: translateY(-1px);
  }
}

.metric-icon {
  align-items: center;
  display: inline-flex;
  font-size: 22px;
  height: 24px;
  justify-content: center;
  width: 24px;

  &--primary {
    color: #1976d2;
  }

  &--success {
    color: #2e7d32;
  }
}

.metric-value {
  color: #181c32;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
}

.funnel-scroll {
  overflow-x: auto;
  padding-bottom: 4px;
}

.funnel {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 auto;
  padding: 16px 0;
  min-width: 1248px;
  width: 1248px;
}

.funnel-step {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 1248px;
}

.funnel-bar {
  align-items: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 108px;
  justify-content: center;
  padding: 16px 24px;
  flex: 0 0 auto;
  text-align: center;
}

.funnel-step:not(:first-child) .funnel-bar {
  height: 128px;
}

.funnel-label {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.funnel-count {
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
}

.funnel-percent {
  font-size: 12px;
  line-height: 16px;
  opacity: 0.9;
}

.funnel-drop {
  color: #e7000b;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin-top: 4px;
  text-align: center;
}

.metric-modal-toolbar {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.metric-modal-total {
  color: #181c32;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
}

.partner-status-filter {
  min-width: 220px;
}

@media (max-width: 1199px) {
  .metric-grid {
    grid-template-columns: repeat(3, minmax(160px, 1fr));
  }
}

@media (max-width: 767px) {
  .summary-grid,
  .metric-grid {
    grid-template-columns: 1fr;
  }

  .metric-modal-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .partner-status-filter {
    min-width: 0;
    width: 100%;
  }
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
}
</style>
